import * as Types from '../../../../graphql.d';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type CreateNewOrderMutationVariables = Types.Exact<{
  orderAttributes: Types.DraftOrderDto;
}>;


export type CreateNewOrderMutation = { __typename?: 'mutation_root', result: { __typename?: 'CreateDraftOrderResponse', success: boolean, orderId: number, session: { __typename?: 'AuthSuccess', type: string, token: string } } };

export type ProductCreateSwapMutationVariables = Types.Exact<{
  nextSubSku: Types.Scalars['String'];
  orderId: Types.Scalars['Int'];
}>;


export type ProductCreateSwapMutation = { __typename?: 'mutation_root', result: { __typename?: 'OrderSwapCreateSwap', orderId: number } };


export const CreateNewOrderDocument = gql`
    mutation createNewOrder($orderAttributes: DraftOrderDto!) {
  result: nest_createDraftOrder(orderAttributes: $orderAttributes) {
    success
    orderId
    session {
      type
      token
    }
  }
}
    `;
export function useCreateNewOrderMutation(baseOptions?: Apollo.MutationHookOptions<CreateNewOrderMutation, CreateNewOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNewOrderMutation, CreateNewOrderMutationVariables>(CreateNewOrderDocument, options);
      }
export type CreateNewOrderMutationHookResult = ReturnType<typeof useCreateNewOrderMutation>;
export type CreateNewOrderMutationResult = Apollo.MutationResult<CreateNewOrderMutation>;
export type CreateNewOrderMutationOptions = Apollo.BaseMutationOptions<CreateNewOrderMutation, CreateNewOrderMutationVariables>;
export const ProductCreateSwapDocument = gql`
    mutation productCreateSwap($nextSubSku: String!, $orderId: Int!) {
  result: nest_orderSwap_createSwap(sku: $nextSubSku, orderId: $orderId) {
    orderId
  }
}
    `;
export function useProductCreateSwapMutation(baseOptions?: Apollo.MutationHookOptions<ProductCreateSwapMutation, ProductCreateSwapMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProductCreateSwapMutation, ProductCreateSwapMutationVariables>(ProductCreateSwapDocument, options);
      }
export type ProductCreateSwapMutationHookResult = ReturnType<typeof useProductCreateSwapMutation>;
export type ProductCreateSwapMutationResult = Apollo.MutationResult<ProductCreateSwapMutation>;
export type ProductCreateSwapMutationOptions = Apollo.BaseMutationOptions<ProductCreateSwapMutation, ProductCreateSwapMutationVariables>;